import { BuildStatus } from 'src/components/types';

export type Conflict = {
  path: string;
  message: string;
  scenario: string;
};

export enum MergeCheckKey {
  MINIMUM_APPROVALS = 'minimum_approvals',
  MINIMUM_DEFAULT_REVIEWER_APPROVALS = 'minimum_default_reviewer_approvals',
  MINIMUM_SUCCESSFUL_BUILDS = 'minimum_successful_builds',
  MAXIMUM_COMMITS_BEHIND = 'maximum_commits_behind',
  REVIEW_GROUPS = 'required_review_group_approvals',
  FAILED_BUILDS = 'failed_builds',
  RESOLVED_TASKS = 'resolved_tasks',
  PR_DEPS_MERGED = 'pr_deps_merged',
  NO_CHANGES_REQUESTED = 'no_changes_requested',
  IN_PROGRESS_BUILDS = 'in_progress_builds',
  NO_RESOLVABLE_COMMENTS = 'resolvable_comments',
}

export type MergeCheck = {
  allow_merge: boolean;
  errors: any[];
  key: MergeCheckKey;
  label?: string;
  name: string;
  pass: boolean;
  count?: number;
};

export type BuildStatusesMap = {
  FAILED: number;
  INPROGRESS: number;
  STOPPED: number;
  SUCCESSFUL: number;
};

export type BuildStatusCount = {
  state: 'SUCCESSFUL' | 'FAILED' | 'INPROGRESS' | 'STOPPED';
  total_counts: number;
  commit_status: BuildStatus;
  status_counts: BuildStatusesMap;
};

export type BuildStatusCountsMap = { [hash: string]: BuildStatusCount };

export enum StatusType {
  UNKNOWN = 'UNKNOWN',
  GPG = 'GPG',
}
export enum SignatureStatus {
  UNKNOWN = 'unknown',
  VALID = 'valid',
  INVALID = 'invalid',
  VALID_BUT_OUT_OF_DATE = 'valid_but_out_of_date',
  VALID_BUT_MADE_AFTER_EXPIRY = 'valid_but_made_after_expiry',
  VALID_BUT_REVOKED = 'valid_but_revoked',
  SIGNATURE_NOT_FOUND = 'signature_not_found',
  PUBLIC_KEY_NOT_FOUND = 'public_key_not_found',
}

export interface VerificationStatus {
  repo_uuid: string;
  hash: string;
  fingerprint: string;
  type: StatusType;
  status: SignatureStatus;
}
